import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
import { MovieService } from './movie.service';
import {db,Category,Livetv } from '../services/dexiedb/livetvdb.service'
import Dexie from 'dexie';
import { Moviesdb } from './dexiedb/moviedb.service';

@Injectable({
  providedIn: 'root'
})
export class LivestreamService {

  domain: any = '';
  username: any = '';
  password: any = '';
  url: any = '';

  Xurl: any;
  Ourl:any;
  OToken:any;


  constructor(public http: HttpClient, public utilService: UtilService,private movieService:MovieService) {
    this.Ourl = this.utilService.getOneStreamUrl();
    this.OToken = this.utilService.getOneStreamToken();
  }

  getDataLcal() {
    this.Xurl = this.utilService.getXstreamUrl();
    console.log("Xurl",this.Xurl);
    
    if (this.Xurl) {
      this.domain = this.utilService.getXstreamUrl();
      this.username = this.utilService.getXstreamUsername();
      this.password = this.utilService.getXstreamPassword();
      
    }else if(this.OToken){
      this.domain = this.utilService.getOneStreamUrl();
    }
    else {
      this.domain = this.utilService.getFullUrl();
      this.username = this.utilService.getFullUsername();
      this.password = this.utilService.getFullPassword();
    }
    if(this.Ourl){
      this.url = this.domain + '/play/b2c/v1/';
      return this.url;
    }else{
    this.url = this.domain + '/player_api.php?username=' + this.username + '&password=' + this.password + '&action=';
    return this.url;
    }
  }

  getRequestType(): 'get' | 'post' {
    return (localStorage.getItem('API') as 'get' | 'post') || 'get';
  }

  async loadLivetvCategories(): Promise<Category[]> {
   const playlist = JSON.parse(localStorage.getItem('playlist') || '{}');
    const playlist_id = playlist.id;
    const existing = await db.categories.where('playlist_id').equals(playlist_id).count();
    
  const count = await db.categories.count();

  if (existing === 0) {
    let categories: Category[] = [];

    if (this.OToken) {
      categories = await this.http
        .get<Category[]>(this.getDataLcal() + 'categories/live?token=' + this.OToken)
        .toPromise();
    } else {
      const reqType = this.getRequestType();
      if (reqType === 'post') {
        categories = await this.movieService
          .postApi('get_live_categories')
          .toPromise();
      } else {
        categories = await this.http
          .get<Category[]>(this.getDataLcal() + 'get_live_categories')
          .toPromise();
      }

    }
    const categoriesWithPlaylistId: Category[] = categories.map(c => ({
          category_id: c.category_id,
          category_name: c.category_name,
          playlist_id: playlist_id}));

    await db.categories.bulkPut(categoriesWithPlaylistId);

  }
  // return await db.categories.toArray();
  return await db.categories.where('playlist_id').equals(playlist_id).toArray();

}

async loadLivetv(): Promise<number> {
    const storedPlaylist = localStorage.getItem('playlist');
     if (!storedPlaylist) return 0;
  
  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;
  const countBefore = await db.livetv.where('playlist_id')
    .equals(playlist_id)
    .count();

  if (countBefore === 0) {
    const livetvRaw: any[] = await this.getLivestreamAll().toPromise();
    console.log('📺 Fetched total live TV streams:', livetvRaw.length);
     // Step 1: Get favorite stream IDs before mapping
    const favStreamIds = (await db.favorites
      .where('playlist_id')
      .equals(playlist_id)
      .toArray()
    ).map(fav => fav.stream_id);

    const mappedLivetv: Livetv[] = livetvRaw.map(m => ({
      playlist_id:playlist_id,
      name: m.name,
      stream_id: String(m.stream_id),
      category_id: m.category_id,
      stream_icon: m.stream_icon,
      epg_channel_id:m.epg_channel_id,
      is_favorite: favStreamIds.includes(m.stream_id) 

    }));

    // Use bulkPut to avoid duplicate key issues
    await db.livetv.bulkPut(mappedLivetv);

    const countAfter = await db.livetv.where('playlist_id').equals(playlist_id).count();
    console.log('💾 Stored live TV streams in IndexedDB:', countAfter);
    return countAfter;
  } else {
    console.log('💾 IndexedDB already has live TV streams:', countBefore);
    return countBefore;
  }
}

async getAllChannel(page: number, limit: number): Promise<Livetv[]> {
   const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return [];

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;
  const offset = (page - 1) * limit;
  return await db.livetv
    .where('playlist_id')
    .equals(playlist_id)
    // .toCollection()      
    .offset(offset)
    .limit(limit)
    .toArray();
}

async getAllChannelSearch(): Promise<Livetv[]> {
   const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return [];

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;
  const livetv = await db.livetv
    .where('playlist_id')
    .equals(playlist_id)
    .toArray();

  // Step 2: Get all favorite stream_ids for this playlist
  const favorites = await db.favorites
    .where('playlist_id')
    .equals(playlist_id)
    .toArray();
  const favoriteIds = favorites.map(f => f.stream_id);

  // Step 3: Map is_favorite flag
  return livetv.map(live => ({
    ...live,
    is_favorite: favoriteIds.includes(live.stream_id)
  }));
  // return await db.livetv.where('playlist_id')
  //     .equals(playlist_id)
  //     .toArray();
}
async getLiveTvPaginated(offset: number = 0, limit: number = 100): Promise<(Livetv & { is_favorite: boolean })[]> {
  const storedPlaylist = localStorage.getItem('playlist');
  if (!storedPlaylist) return [];

  const playlist = JSON.parse(storedPlaylist);
  const playlist_id = playlist.id;

  // Step 1: Get paginated Live TV channels
  const livetv = await db.livetv
    .where('playlist_id')
    .equals(playlist_id)
    .offset(offset)
    .limit(limit)
    .toArray();

  // Step 2: Get favorites
  const favorites = await db.favorites
    .where('playlist_id')
    .equals(playlist_id)
    .toArray();
  const favoriteIds = new Set(favorites.map(f => f.stream_id));

  // Step 3: Map favorites
  return livetv.map(live => ({
    ...live,
    is_favorite: favoriteIds.has(live.stream_id)
  }));
}


  
  async getLivetvByCategory(
    categoryId: string,
    page = 1,
    limit = 50
  ): Promise<Livetv[]> {
    const offset = (page - 1) * limit;
     const storedPlaylist = localStorage.getItem('playlist');
    if (!storedPlaylist) return [];

    const playlist = JSON.parse(storedPlaylist);
    const playlist_id = playlist.id;
    let collection: Dexie.Collection<Livetv, any>;
    if (categoryId === 'all') {
      // no where-clause → all movies
      collection = db.livetv
      .where('playlist_id')
      .equals(playlist_id);
    } else {
      // filtered by category
      collection = db.livetv
      .where('[playlist_id+category_id]')
      .equals([playlist_id, categoryId]);
    }
  
    const results = await collection
      .offset(offset)
      .limit(limit)
      .toArray();
  
    console.log(`Category '${categoryId}' → ${results.length} livtv`);
    return results;
  
  }


  //search category
  async getLivetvByCategoryForSearch(categoryId: string): Promise<Livetv[]> {
    const storedPlaylist = localStorage.getItem('playlist');
    if (!storedPlaylist) return [];
  
    const playlist = JSON.parse(storedPlaylist);
    const playlist_id = playlist.id;
  
    // Step 1: Get movies by category
    let livetv: Livetv[] = [];
    if (categoryId === 'all') {
      livetv = await db.livetv
        .where('playlist_id')
        .equals(playlist_id)
        .toArray();
    } else {
      livetv = await db.livetv
        .where('[playlist_id+category_id]')
        .equals([playlist_id, categoryId])
        .toArray();
    }
  
    // Step 2: Get favorites for this playlist
    const favorites = await db.favorites
      .where('playlist_id')
      .equals(playlist_id)
      .toArray();
    const favStreamIds = favorites.map(fav => fav.stream_id);
  
    // Step 3: Mark is_favorite flag
    return livetv.map(live => ({
      ...live,
      is_favorite: favStreamIds.includes(live.stream_id)
    }));
  }
  
    
  
  
  
    // ✅ Mark a movie as favorite
    async markAsFavorite(playlistId: number, streamId: string): Promise<void> {
      console.log(playlistId,streamId);
      
      await db.favorites.put({ playlist_id: playlistId, stream_id: streamId });
    }
  
    // ✅ Unmark a movie as favorite
    async unmarkAsFavorite(playlistId: number, streamId: string): Promise<void> {
      await db.favorites.delete([playlistId, streamId]);
    }
  
    async getLivetvById(playlistId: number, ids: string[]): Promise<Livetv[]> {
      const allMovies = await db.livetv
        .where('playlist_id')
        .equals(playlistId)
        .toArray();
    
      // Filter movies where stream_id matches one of the content_ids
      return allMovies.filter(movie => ids.includes(String(movie.stream_id)));
    }
    // ✅ Toggle favorite
    async toggleFavorite(playlistId: number, streamId: string): Promise<void> {
      const isFav = await db.favorites.get([playlistId, streamId]);
      if (isFav) {
        await this.unmarkAsFavorite(playlistId, streamId);
      } else {
        await this.markAsFavorite(playlistId, streamId);
      }
    }
  
    // ✅ Get all favorite movie stream IDs for a playlist
    async getFavoriteStreamIds(playlistId: number): Promise<string[]> {
      const favs = await db.favorites
        .where('playlist_id')
        .equals(playlistId)
        .toArray();
  
      return favs.map(f => f.stream_id);
    }
  
    // ✅ Get all favorite movie details for a playlist
    async getFavoriteMovies(playlistId: number): Promise<Livetv[]> {
      const streamIds = await this.getFavoriteStreamIds(playlistId);
    
      const livetv = await Promise.all(
        streamIds.map(id => db.livetv.get([playlistId, id]))
      );
    
      return livetv.filter((m): m is Livetv => !!m);
    }
      
  
    // ✅ Check if a specific movie is favorite
    async isFavorite(playlistId: number, streamId: string): Promise<boolean> {
      const fav = await db.favorites.get([playlistId, streamId]);
      return !!fav;
    }


  //refresh db
  async loadLivetvdbCategories(forceRefresh = false): Promise<Category[]> {
  const playlist = JSON.parse(localStorage.getItem('playlist') || '{}');
  const playlist_id = playlist.id;

  const existing = await db.categories.where('playlist_id').equals(playlist_id).count();

  if (existing === 0 || forceRefresh) {
    // Fetch from API
    let categories: Category[] = [];

    if (this.OToken) {
      categories = await this.http
        .get<Category[]>(this.getDataLcal() + 'categories/live?token=' + this.OToken)
        .toPromise();
    } else {
      const reqType = this.getRequestType();
      if (reqType === 'post') {
        categories = await this.movieService.postApi('get_live_categories').toPromise();
      } else {
        categories = await this.http
          .get<Category[]>(this.getDataLcal() + 'get_live_categories')
          .toPromise();
      }
    }

    const categoriesWithPlaylistId: Category[] = categories.map(c => ({
      ...c,
      playlist_id: playlist_id
    }));

    // 🧼 Clear existing categories for this playlist
    await db.categories.where('playlist_id').equals(playlist_id).delete();

    // 🆕 Add new ones
    await db.categories.bulkPut(categoriesWithPlaylistId);
  }

  return await db.categories.where('playlist_id').equals(playlist_id).toArray();
}

async loadLivetvdb(forceRefresh = false): Promise<number> {
  const playlist = JSON.parse(localStorage.getItem('playlist') || '{}');
  const playlist_id = playlist.id;

  const countBefore = await db.livetv.where('playlist_id').equals(playlist_id).count();

  if (countBefore === 0 || forceRefresh) {
    // 1. Get current favorites
    const favoriteStreamIds = new Set(
      (await db.favorites.where('playlist_id').equals(playlist_id).toArray())
        .map(fav => fav.stream_id)
    );

    // 2. Fetch all live TV data from API
    const livetvRaw: any[] = await this.getLivestreamAll().toPromise();
    console.log('📺 Fetched live TV streams:', livetvRaw.length);

    // 3. Clear existing for this playlist
    await db.livetv.where('playlist_id').equals(playlist_id).delete();

    // 4. Map data with `is_favorite` flag
    const mappedLivetv: Livetv[] = livetvRaw.map(m => ({
      playlist_id,
      name: m.name,
      stream_id: String(m.stream_id),
      category_id: m.category_id,
      stream_icon: m.stream_icon,
      epg_channel_id: m.epg_channel_id,
      is_favorite: favoriteStreamIds.has(String(m.stream_id))
    }));

    // 5. Store updated data
    await db.livetv.bulkPut(mappedLivetv);

    const countAfter = await db.livetv.where('playlist_id').equals(playlist_id).count();
    console.log('💾 Stored updated live TV:', countAfter);
    return countAfter;
  } else {
    console.log('✅ LiveTV already exists:', countBefore);
    return countBefore;
  }
}



//end dexiedb

  public getliveCategories() {
    if(this.OToken){
      return this.http.get(this.getDataLcal() + 'categories/live?token=' + this.OToken)
    }else{
      const reqType = this.getRequestType()
      if (reqType == 'post') {
        return this.movieService.postApi('get_live_categories');
      }else if(reqType == 'get'){    
        return this.http.get(this.getDataLcal() + 'get_live_categories');
      }
    }
  }


  public getCategorywiseChannelList(id: any) {
    if(this.OToken){
      return this.http.get(this.getDataLcal() + `content/live?token=${this.OToken}&category_id=${id}`);
    }else{
      const reqType = this.getRequestType();
      if (reqType == 'post') {
        return this.movieService.postApi('get_live_streams', { category_id: id });
      }else if(reqType == 'get'){    
        return this.http.get(this.getDataLcal() + 'get_live_streams&category_id=' + id);
      }
    }
  }


  public getCategorywiseChannelLists(){
    if(this.OToken){
      return this.http.get(this.getDataLcal() + `content/live?token=${this.OToken}&category_id=all`);
    }else{
      const reqType = this.getRequestType();
      if (reqType == 'post') {
        return this.movieService.postApi('get_live_streams');
      }else if(reqType == 'get'){    
        return this.http.get(this.getDataLcal() + 'get_live_streams');
      }
      // return this.http.get(this.getDataLcal() + 'get_live_streams');
    }
  }
  public getStreamURL(streamid: any,format:any) {
    this.getDataLcal();
    return (this.domain + '/live/' + this.username + '/' + this.password + '/' + streamid + format).replace(environment.cdnurl,'');
  }
  public getLivestreamAll(){
    if(this.OToken){
      return this.http.get(this.getDataLcal() + `content/live?token=${this.OToken}&category_id=all`);
    }else{
      const reqType = this.getRequestType();
      if (reqType == 'post') {
        return this.movieService.postApi('get_live_streams');
      }else if(reqType == 'get'){    
        return this.http.get(this.getDataLcal() + 'get_live_streams');
      }
    }
    
  }

  public getshortEpg(id:any){
    if(this.OToken){
      return this.http.get(this.getDataLcal() + `epg/${id}/short?token=${this.OToken}`);
    }else{ 
      const reqType = this.getRequestType();
      if (reqType == 'post') {
        return this.movieService.postApi('get_short_epg', { stream_id: id });
      }else if(reqType == 'get'){    
        // return this.http.get(this.getDataLcal() + 'get_live_streams&category_id=' + id);
        return this.http.get(this.getDataLcal() + 'get_short_epg&stream_id='+id);
      }
    }
}
}

export {Livetv};
